import React, { Fragment } from 'react';
import { translate } from 'translations/i18n';
import styled from 'styled-components';
import { Text, Button } from '@companycam/slab-web';
import { useModal } from 'components/shared/hooks';

import toast from 'helpers/toast';
import { useDeleteShowcaseProject } from 'javascripts/data/v3/showcases';

const Title = styled(Text)`
  margin: 0 0 24px;
`;

const Description = styled(Text)`
  margin-bottom: 24px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: var(--cc_size_spacing_m);
`;

type DeleteConfirmProps = {
  cancelConfirm: () => void;
  projectDatabaseId?: number;
  onSuccessfulDelete?: () => void;
};

const DeleteConfirm = ({
  cancelConfirm,
  projectDatabaseId,
  onSuccessfulDelete,
}: DeleteConfirmProps) => {
  const { hideModal } = useModal();

  const deleteShowcaseProject = useDeleteShowcaseProject({
    onSuccess: () => {
      toast.success(
        translate('showcases.publishDropdown.deleteShowcaseModal.success'),
      );
      onSuccessfulDelete?.();
      hideModal();
    },
    onError: () => {
      toast.error(
        translate('showcases.publishDropdown.deleteShowcaseModal.error'),
      );
    },
  });

  const handleDelete = () => {
    if (projectDatabaseId) {
      deleteShowcaseProject.mutate(Number(projectDatabaseId));
    }
  };

  const isLoading = deleteShowcaseProject.isPending;
  return (
    <Fragment>
      <Title as="h2">
        {translate('showcases.create.publishWizard.deleteConfirm.heading')}
      </Title>
      <Description as="p">
        {translate('showcases.create.publishWizard.deleteConfirm.description')}
      </Description>
      <ButtonContainer>
        <Button
          color="destroy"
          loading={isLoading}
          disabled={isLoading}
          onClick={handleDelete}
        >
          {translate(
            'showcases.create.publishWizard.deleteConfirm.confirmButton',
          )}
        </Button>
        <Button
          onClick={cancelConfirm}
          loading={isLoading}
          disabled={isLoading}
        >
          {translate(
            'showcases.create.publishWizard.deleteConfirm.cancelButton',
          )}
        </Button>
      </ButtonContainer>
    </Fragment>
  );
};

export default DeleteConfirm;
